import React, { useState, useEffect, useLayoutEffect } from 'react';
import { Button } from "../atoms/button";
import useMedia from 'use-media';
import { connect, useStore } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { InputForm } from '../molecules/inputForm';
import { ReserverInputheader } from "../molecules/reserverInputheader";
import { Label } from '../atoms/label';
import { TextArea } from "../atoms/textArea";
import { GolfFooterContainer } from "./golfFooterContainer";
import common from "../../resources/js/common/common"
import constant from "../../const/Const";
import { versionGetApi } from '../../const';
import { apiKeyCheck } from '../../const';
import commonUtil from '../../common/commonUtil';
import '../../resources/css/soloReserve/golfSoloInput.css'
import { useRtoaster } from '../../hooks/useRtoaster';

const GolfSoloInputContainer = (props) => {
    const {
        golfSoloTeetime,
        setGolfSoloTeetime,
        golfSoloSearchData,
        login,
        changeReserveNo,
        state,
        golfLocation
    } = props;

    const store = useStore();

    // 空文字チェック
    const [emptyChecked, setEmptyChecked] = useState(false);
    // 文字列数チェック
    const [strLenChecked, setStrLenChecked] = useState(false);
    // メールアドレスフォーマットチェック
    const [emailFormatChecked, setEmailFormatChecked] = useState(false);
    // 電話番号フォーマットチェック
    const [phoneFormatChecked, setPhoneFormatChcked] = useState(false);

    const [reserverSurnameKanji, setReserverSurnameKanji] = useState("");
    const [reserverNameKanji, setReserverNameKanji] = useState("");
    const [emailAddress, setEmailAddress] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [remark, setRemark] = useState("");

    const loginUserInfo = login.loginUserInfo;

    const history = useHistory();

    //レスポンシブ対応
    const isWidePhone = useMedia({ maxWidth: '480px' });
    const isWideTablet = useMedia({ maxWidth: '960px' });
    const [Phone, setPhone] = useState(false);
    const [Tablet, setTablet] = useState(false);

    // rtoasterタグ生成
    const customParam = {
        "sisetucd": golfSoloSearchData.golfCourseId,
        "riyodat": golfSoloSearchData.playDate,
        "keiyakuno": golfSoloSearchData.contractNo,
        "packcd": golfSoloSearchData.planId,
        "packnam": golfSoloSearchData.planName,
        "coursecd": golfSoloTeetime.courseId,
        "startjikan": golfSoloTeetime.startTime,
    }
    useRtoaster(history.location.pathname, customParam);

    useEffect(() => {
        if (isWideTablet && isWidePhone) {
            setPhone(true);
            setTablet(false);
        }
        else if (isWideTablet && !isWidePhone) {
            setPhone(false);
            setTablet(true);
        }
        else if (!isWideTablet && isWidePhone) {
            setTablet(false);
            setPhone(true);
        }
        else {
            setPhone(false);
            setTablet(false);
        }
    })

    useLayoutEffect(() => {
        // リフレッシュ対応
        let state = store.getState().login;
        let apiKey = null;
        if (Object.keys(state).length !== 0) {
            apiKey = state.apiKey;
        }
        if (apiKey === null) {
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
        if (apiKey) {
            common.doPost(apiKeyCheck, { apikey: apiKey }, afterApiKeyCheck);
        }
    })
    const afterApiKeyCheck = (res) => {
        if (!res.data) {
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
    }

    // 初期表示
    useEffect(() => {
        common.doPost(versionGetApi, {}, afterVerCheck);

        setGolfSoloTeetime(
            {
                ...golfSoloTeetime,
                playDate: golfSoloSearchData.playDate,
            }
            );
        if (loginUserInfo) {
            // 姓(漢字)
            setReserverSurnameKanji(loginUserInfo.memberSei ? loginUserInfo.memberSei : "");
            // 名(漢字)
            setReserverNameKanji(loginUserInfo.memberMei ? loginUserInfo.memberMei : "");
            // 予約連絡先メールアドレス
            if (loginUserInfo.mobileAddress) {
                setEmailAddress(loginUserInfo.mobileAddress);
            }
            else if (loginUserInfo.pcAddress) {
                setEmailAddress(loginUserInfo.pcAddress);
            }

            // 予約連絡先電話番号
            if (loginUserInfo.mobilePhone) {
                var phoneStr = loginUserInfo.mobilePhone;
                var mobileResult = phoneStr.replace("-", "");
                while (mobileResult !== phoneStr) {
                    phoneStr = phoneStr.replace("-", "");
                    mobileResult = mobileResult.replace("-", "");
                }
                setPhoneNumber(mobileResult);
            }
            else if (loginUserInfo.phone) {
                var phoneStr2 = loginUserInfo.phone;
                var phoneResult = phoneStr2.replace("-", "");
                while (phoneResult !== phoneStr2) {
                    phoneStr2 = phoneStr2.replace("-", "");
                    phoneResult = phoneResult.replace("-", "");
                }
                setPhoneNumber(phoneResult);
            }
        }

        const elements = document.getElementsByClassName("representChecked");
        let checkId = "";
        for (let i = 0; i < elements.length; i++) {
            if (elements[i].checked) {
                checkId = elements[i].id;
            }
        }
        if (checkId !== "") {
            for (let i = 0; i < elements.length; i++) {
                if (elements[i].id !== checkId) {
                    elements[i].disabled = true;
                }
            }
        }
        common.scrollWindowTop();
    }, []);


    const afterVerCheck = (res) => {
        let flg = common.versionCheck(res.data.version);
        if (flg) {
            history.push("/reserve/login");
            return;
        }
    }

    const onClickBack = () => {
        history.push("/reserve/golf/soloStartTime");
    };

    // 空文字チェック
    const checkEmpty = (value) => {
        if (value === "") {
            return true;
        } else {
            return false;
        }
    }

    // 文字列数チェック(メールアドレス)
    const checkStrLen = (value) => {
        if (value.length > 256) {
            return true;
        } else {
            return false;
        }
    }

    // メールアドレスフォーマットチェック
    const checkEmailFormat = (value) => {
        let reg = new RegExp("^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}.[A-Za-z0-9]{1,}$");
        if (!reg.test(value)) {
            return true;
        } else {
            return false;
        }
    }

    // 電話番号フォーマットチェック
    const checkPhoneFormat = (value) => {
        let reg = new RegExp("^[0-9]*$", "g");
        if (!reg.test(value)) {
            return true;
        } else {
            return false;
        }
    }

    const htmlsanitize = (str) => {
        return String(str).replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
    }


    const determination = () => {

        const emailAddress = document.getElementById("email_address");
        const phoneNumber = document.getElementById("phone_number");
        const remark = document.getElementById("reserver_note");
        setEmailAddress(emailAddress.value);
        setPhoneNumber(phoneNumber.value);
        setRemark(remark.value);

        // DOMリセット
        emailAddress.style.backgroundColor = "";
        phoneNumber.style.backgroundColor = "";

        // 空文字チェック
        let emptyFlag = false;
        let unmatchFlag = false;
        let flg5 = checkEmpty(emailAddress.value);
        if (flg5 === true) emailAddress.style.backgroundColor = constant.ERROR_COLOR;
        let flg6 = checkEmpty(phoneNumber.value);
        if (flg6 === true) phoneNumber.style.backgroundColor = constant.ERROR_COLOR;
        setEmptyChecked(false);
        if(flg5 || flg6) {
            emptyFlag = true;
            setEmptyChecked(true);
        }

        // 文字列数チェック
        let strLenFlag = false;
        strLenFlag = checkStrLen(emailAddress.value);
        if (strLenFlag === true) emailAddress.style.backgroundColor = constant.ERROR_COLOR;
        setStrLenChecked(strLenFlag);

        // メールアドレスフォーマットチェック
        let emailFormatFlag = false;
        if (flg5 === false) {
            emailFormatFlag = checkEmailFormat(emailAddress.value);
            if (emailFormatFlag === true) emailAddress.style.backgroundColor = constant.ERROR_COLOR;
            setEmailFormatChecked(emailFormatFlag);
        }

        // 電話番号フォーマットチェック
        let phoneFormatFlag = false;
        phoneFormatFlag = checkPhoneFormat(phoneNumber.value);
        if (phoneFormatFlag === true) phoneNumber.style.backgroundColor = constant.ERROR_COLOR;
        setPhoneFormatChcked(phoneFormatFlag);

        if (emptyFlag || strLenFlag || emailFormatFlag || phoneFormatFlag || unmatchFlag) {
            common.scrollWindow("pagetop");
            return;
        }else{
            const loginUserInfo = login.loginUserInfo;
            const playerInfo = {
                mailAddress: htmlsanitize(emailAddress.value),
                phone: htmlsanitize(phoneNumber.value),
                remark: htmlsanitize(remark.value),
                familyName:reserverSurnameKanji,
                firstName:reserverNameKanji,
                familyNameKana:loginUserInfo.memberSeiKana,
                firstNameKana:loginUserInfo.memberMeiKana,
                applicationFamilyName:reserverSurnameKanji,
                applicationFirstName:reserverNameKanji,
                genderType: loginUserInfo.sexCode == "01" ? 0 : loginUserInfo.sexCode == "02" ? 1 : 9,
                ttbLoginUserId: login.memberCode,
                addressPref: loginUserInfo.address1,
                playerName: loginUserInfo.memberSei + loginUserInfo.memberMei,
                playerNameKana: loginUserInfo.memberSeiKana + loginUserInfo.memberMeiKana,
            }
            // 入力情報
            setGolfSoloTeetime({ ...golfSoloTeetime, playerInfo })
            history.push("/reserve/golf/soloConfirm");
        }
    }

    return (
        <div className='soloInput_top' >
            <div className='soloInput_breadCrumb'>
                <Link to={"/reserve/top"} className='soloInput_link' >HOME</Link>
                <Label label=">" className='soloInput_breadCrumbArrow' />
                <Link to={"/reserve/golf/soloSearch"} className='soloInput_link' >ゴルフ一人予約</Link>
                <Label label=">" className='soloInput_breadCrumbArrow' />
                <Link to={"/reserve/golf/soloStartTime"} className='soloInput_link' >スタート時間</Link>
                <Label label=">" className='soloInput_breadCrumbArrow' />
                <Label label="利用者入力" className='soloInput_link' />
            </div>
            <div className='soloInput_planInfoArea'>
                <Label label={"プレー日：" + commonUtil.getStringFromDateJpnGolf(golfSoloTeetime?.playDate)} className='soloInput_planInfoBody' />
                <Label label={"ゴルフ場：" + golfSoloTeetime?.golfCourseName} className='soloInput_planInfoBody' />
            </div>
            <div id="pagetop" className='soloInput_base'>
                <ReserverInputheader label1={"利用者"} />
                <div className='soloInput_form'>
                    <div className='soloInput_errorDiv'>
                        <div className={emptyChecked ? 'soloInput_errorDiv' : 'hiddenItem'}>必須項目を入力してください</div>
                        <div className={strLenChecked ? 'soloInput_errorDiv' : 'hiddenItem'}>メールアドレスは半角256文字以内で入力願います</div>
                        <div className={emailFormatChecked ? 'soloInput_errorDiv' : 'hiddenItem'}>メールアドレスが不正です</div>
                        <div className={phoneFormatChecked ? 'soloInput_errorDiv' : 'hiddenItem'}>電話番号はハイフンなしの数字で入力ください</div>
                    </div>
                    <div className='soloInput_flex'>
                        <div className='soloInput_nameWrapper'>
                            <Label label="姓(漢字)" className="soloInput_label" />
                            <Label label={reserverSurnameKanji} />
                        </div>
                        <div className='soloInput_nameWrapper'>
                            <Label label="名(漢字)" className="soloInput_label" />
                            <Label label={reserverNameKanji} />
                        </div>
                    </div>
                    <div className='soloInput_flex'>
                        <InputForm
                            label={"予約連絡先メールアドレス"}
                            type={"text"}
                            labelClass="soloInput_label"
                            id={`email_address`}
                            maxLength={"256"}
                            value={golfSoloTeetime?.playerInfo?.mailAddress !== undefined ? golfSoloTeetime.playerInfo.mailAddress : emailAddress != undefined ? emailAddress : ""}
                            placeholder={""}
                        />
                    </div>
                    <div className='soloInput_flex'>
                        <InputForm
                            label={"予約連絡先電話番号"}
                            type={"text"}
                            labelClass='soloInput_label'
                            id={`phone_number`}
                            maxLength={"11"}
                            value={golfSoloTeetime?.playerInfo?.phone !== undefined ? golfSoloTeetime.playerInfo.phone : phoneNumber != undefined ? phoneNumber : ""}
                            placeholder={""}
                        />
                    </div>
                    <div>
                        <Label className='soloInput_label' label={"備考"} />
                        <TextArea 
                            className='soloInput_bikou'
                            cols={60}
                            rows={6}
                            id={`reserver_note`}
                            value={golfSoloTeetime?.playerInfo?.remark !== undefined ? golfSoloTeetime.playerInfo.remark : remark != undefined ? remark : ""} />
                    </div>
                </div>
                <div className='soloInput_box'>
                    <Button buttonText="戻 る" className={isWideTablet ? "backBtnSp" : "backBtnPc"} onClick={onClickBack} />
                    <Button buttonText="確認画面へ" className={isWideTablet ? "useBtnSp" : "useBtnPc"} onClick={determination} />
                </div>
                <Link className='soloInput_reserveLink' to="/reserve/golf/soloSearch" >ゴルフ一人予約TOPに戻る</Link>
            </div>
            <div className='soloInput_footer'>
                <GolfFooterContainer />
            </div>
        </div >

    )
}

const mapStateToProps = (state) => {
    return {
        golfSoloTeetime: state.golfSoloTeetime,
        golfSoloSearchData: state.golfSoloSearchData,
        login: state.login,
    };
};

const mapToDispatchToProps = (dispatch) => {
    return {
        setGolfSoloTeetime: (item) => {
            dispatch({ type: "GOLF_SOLO_TEETIME", payload: { golfSoloTeetime: item } })
        },
    };
}

export default connect(mapStateToProps, mapToDispatchToProps)(GolfSoloInputContainer);
